import './style.scss'
import { AbsoluteContainer, AppSpan, AppText, CustomContainer, FixedContainer, FlexColumn } from "src/style"
import {ReactComponent as MapIcon} from 'src/assets/svg/map-icon.svg'
import {ReactComponent as LocationIcon} from 'src/assets/svg/location-icon.svg'

export const PreauthSideContent = () => {
    return (
        <FixedContainer
            top="0"
            left="0"
            height="full"
            width="42.8"
            zIndex="1"
            className="preauth-side-content-body"
        >
            <FlexColumn
                bgColor="#1D1D1D"
                height="100" 
                hUnit="%"
                padding="3"
                rightPadding='5'
                gap='2'
                justifyContent='space-between'
                className='preauth-side-content-wrapper'
            >
                <CustomContainer />
                <MapIcon className='icon-component' />
                <AppText
                    textSize='1.6'
                    color='#ffffff' bottomMargin='4'
                >
                    Lorem ac, arcu, at sed vestibulum, malesuada. Amet, orci ultrices pellentesque aliquam nec. 
                </AppText>
                <AbsoluteContainer bottom='-1.5' left='-1.5'>
                    <LocationIcon className='icon-component' />
                </AbsoluteContainer>
            </FlexColumn>
        </FixedContainer>
    )
}